import { ArrowLeft, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import Page from "src/layouts/Page";

const EditRole = () => {
	return (
		<Page>
			<div className="flex flex-col gap-4">
				<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
					<label className="font-heading text-lg font-medium text-foreground mb-4 block">
						Edit Role
					</label>
					<div className="flex flex-col items-center justify-center py-16 text-center">
						<div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-4">
							<Shield className="w-7 h-7 text-primary" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-foreground mb-1">
							Coming soon
						</p>
						<p className="text-[13px] text-muted-foreground max-w-md">
							This form will let you edit the role name and update its
							permissions.
						</p>
					</div>
				</div>

				<div className="pt-2">
					<Link
						to="/users/permissions"
						className="flex items-center gap-2 text-sm text-zinc-500 hover:text-foreground transition-colors"
					>
						<ArrowLeft size={16} aria-hidden="true" />
						Back to Permissions
					</Link>
				</div>
			</div>
		</Page>
	);
};

export default EditRole;
